import { useState, useEffect } from 'react';

export const useDate = (refreshTime) => {
  const [date, setDate] = useState(new Date());

  const interval = refreshTime || 15;

  useEffect(() => {
    // update value X seconds
    const timer = setInterval(() => {
      setDate(new Date());
    }, interval * 1000);

    return () => clearInterval(timer); // clean up timer
  }, [interval]);

  return { date };
}
